import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron_down",
  "use": "chevron_down-usage",
  "viewBox": "0 0 15 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 9\" id=\"chevron_down\"><path d=\"M.293 1.265a1 1 0 0 1 1.414 0l5.32 5.32 5.376-5.375a1 1 0 1 1 1.414 1.414L7.734 8.707a1 1 0 0 1-1.414 0L.293 2.68a1 1 0 0 1 0-1.414z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol